let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bl7zF")).then(() => parcelRequire('aaQJa'));